import { Button, Spacer } from '@odekoteam/doppio';
import { useState } from 'react';

import { useAppDispatch, useAppSelector } from '../../hooks/store';
import {
  nightEndSelector,
  selectedWarehouseIdSelector,
} from '../../state/selectors/delivery';
import { modalSelector } from '../../state/selectors/modal';
import { moveDeliveryStopsToCustomerPickup } from '../../state/slices/delivery';
import { hideModal } from '../../state/slices/modal';
import CancelButton from './CancelButton';
import { buttonContainer, styledConfirmationModal } from './styles';

export const MOVE_TO_PICKUP_TITLE = 'Move stop to Customer Pick Ups?';
export const MOVE_TO_PICKUP_BODY =
  'This stop will no longer be delivered on a route. The customer picks the order up at the warehouse instead.';

export function MoveStopToCustomerPickupModal(): JSX.Element {
  const dispatch = useAppDispatch();
  const nightEnd = useAppSelector(nightEndSelector);
  const { variables } = useAppSelector(modalSelector);
  const selectedWarehouseId = useAppSelector(selectedWarehouseIdSelector);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const stopId: string | undefined = variables?.stopId;

  const handleOnClickConfirm = async (): Promise<void> => {
    if (!stopId || !selectedWarehouseId || !nightEnd?.viewing) {
      dispatch(hideModal());
      return;
    }
    setIsSubmitting(true);
    await dispatch(
      moveDeliveryStopsToCustomerPickup({
        stopIds: [stopId],
        warehouseId: selectedWarehouseId,
        nightEnd: nightEnd.viewing,
      }),
    );
    setIsSubmitting(false);
    dispatch(hideModal());
  };

  return (
    <div
      id="move-stop-to-customer-pickup-modal"
      sx={{ ...styledConfirmationModal, textAlign: 'left' }}
    >
      <div sx={{ variant: 'text.headingSm' }}>{MOVE_TO_PICKUP_TITLE}</div>
      <Spacer height="$3" />
      <div sx={{ variant: 'text.paragraphMdDefault', color: 'secondaryText' }}>
        {MOVE_TO_PICKUP_BODY}
      </div>
      <div sx={{ ...buttonContainer, justifyContent: 'flex-start' }}>
        <Button
          variant="primary"
          id="move-stop-to-customer-pickup-action-button"
          data-test-id="move-stop-to-customer-pickup-action-button"
          onPress={handleOnClickConfirm}
          isDisabled={isSubmitting}
        >
          {isSubmitting ? 'Moving...' : 'Move to Customer Pick Ups'}
        </Button>
        <Spacer width="$2" />
        <CancelButton variant="secondary" />
      </div>
    </div>
  );
}
